import React from "react";
import { Award, Lock } from "lucide-react";

const STYLE = {
  warmth_7: "bg-sage",
  warmth_30: "bg-accent",
  warmth_100: "bg-primary text-primary-foreground",
};

export const StreakBadges = ({ badges }) => {
  if (!badges?.length) return null;
  return (
    <div className="flex flex-wrap gap-3 mb-6" data-testid="streak-badges">
      {badges.map((badge) => (
        <div
          key={badge.id}
          data-testid={`badge-${badge.id}${badge.earned ? "-earned" : "-locked"}`}
          title={badge.earned ? `Earned ${badge.earned_at?.slice(0, 10)}` : `Reach a ${badge.threshold}-day warmth streak`}
          className={`brutal-card px-3 py-2 flex items-center gap-2 ${badge.earned ? STYLE[badge.id] || "bg-accent" : "bg-card opacity-50"}`}
        >
          {badge.earned ? <Award size={16} strokeWidth={2.5} /> : <Lock size={14} strokeWidth={2.5} />}
          <div>
            <div className="text-xs font-bold leading-tight">{badge.label}</div>
            <div className="text-[10px] opacity-70">{badge.threshold}-day streak</div>
          </div>
        </div>
      ))}
    </div>
  );
};
